export default "__VITE_PUBLIC_ASSET__84805045__"